export const creditCardFieldError = (showError: boolean, message: string = '') => {
    const label = document.querySelector('[for="card-number-secure-field"]');
    const input = document.getElementById('card-number-container');
    const helperError = document.querySelector('.helper-text-error');

    if (helperError) {
        helperError.remove();
    }

    if (label && showError) {
        label.classList.add('label-error');
        const div = document.createElement('div');

        div.classList.add('helper-text-error');

        div.innerHTML = `
            <span class="material-icons">info</span>
            <p>${message}</p>
        `;

        label.insertAdjacentElement('afterend', div);
    }

    if (input && showError) {
        input.classList.add('input-error');
    }

    if (showError === false) {
       label?.classList.remove('label-error');
       input?.classList.remove('input-error');
    }
}

export const addErrorInButton = (disabled:boolean = true) => {
    const button = document.querySelector('button[type=submit]');

    if (!button) {
        return;
    }

    button.classList.add('payment-error');

    if (disabled) {
        button.setAttribute('disabled', '');
    } else {
        button.removeAttribute('disabled');
    }
}